import React from 'react';
import styles from './TenantCardGeneral.module.scss';
import cn from 'classnames';
import { texts } from '../../../constants/texts';
import BtnsActionsTenant from '../BtnsActionsTenant/BtnsActionsTenant';
import { Tooltip } from 'antd';
import PhoneNumber from '../../../../../components/PhoneNumber/PhoneNumber';
import { TenantEmail } from '../../common/TenantEmail/TenantEmail';
import AppBlock from '../../common/AppBlock/AppBlock';
import DocumentTenantBtn from '../DocumentTenantBtn/DocumentTenantBtn';
import { TransportTenantBtn } from '../TransportTenant';
import useCurrentAddress from '../../../hooks/useCurrentAddress';
import TenantViewBtn from '../TenantViewBtn/TenantViewBtn';
import useDeleteTenantComfirm from '../../../hooks/useDeleteTenantComfirm';

const TenantCardGeneral = ({
  className,
  tenant,
  bgColorElement = '#F3F7FC',
  onChangeButtonClick,
  addressId,
  hasVisibleDocs = true,
  ...props
}) => {
  const showFio = !!tenant.fio;
  const showName = !!tenant.name;
  const showSourceClientAddresses = !!tenant?.sourceClientAddresses?.name;
  const showPhone = !!tenant.phone.length;
  const showEmail = !!tenant.email;

  const address = useCurrentAddress();

  const { handleDeleteTenant, isLoadingDeleteTenant } =
    useDeleteTenantComfirm();

  const handleDelete = () => {
    handleDeleteTenant({
      address,
      addressId,
      phone: tenant?.phone,
      tenantId: tenant?.id,
      tenantBindId: tenant.bindId,
    });
  };

  return (
    <div className={cn(styles.root, className)} {...props}>
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <div className={styles.headerText}>
            {tenant.isOwner ? texts.owner : texts.tenant}
          </div>
          <TenantViewBtn tenant={tenant} addressId={addressId} />
        </div>
        <BtnsActionsTenant
          onChangeButtonClick={onChangeButtonClick}
          handleDeleteTenant={handleDelete}
          isLoadingDelete={isLoadingDeleteTenant}
        />
      </div>

      <div className={styles.content}>
        <div className={styles.contentFlexBox}>
          {showFio && (
            <div
              className={styles.flexBox}
              style={{ backgroundColor: bgColorElement }}
            >
              <span className={styles.pointText}>ФИО:</span>
              <span>{tenant.fio}</span>
            </div>
          )}
          {showName && (
            <div
              className={styles.flexBox}
              style={{ backgroundColor: bgColorElement }}
            >
              <span className={styles.pointText}>Псевдоним:</span>
              <Tooltip title="Псевдоним, введенный в МП собственника">
                <span>{tenant.name}</span>
              </Tooltip>
            </div>
          )}
          {showSourceClientAddresses && (
            <div
              className={styles.flexBox}
              style={{ backgroundColor: bgColorElement }}
            >
              <span className={styles.pointText}>Источник:</span>
              <Tooltip title="Источник привязки собственника">
                <span>{tenant?.sourceClientAddresses?.name}</span>
              </Tooltip>
            </div>
          )}
          {showPhone && (
            <div
              className={styles.flexBox}
              style={{ backgroundColor: bgColorElement }}
            >
              {Array.isArray(tenant.phone) &&
                tenant.phone.map((telNum, index) => {
                  if (index !== 0) {
                    return (
                      <PhoneNumber phoneNumber={telNum} name={tenant.name} />
                    );
                  }

                  return (
                    <PhoneNumber phoneNumber={telNum} name={tenant.name} />
                  );
                })}
              {!Array.isArray(tenant.phone) && (
                <PhoneNumber
                  isIcon
                  phoneNumber={tenant.phone}
                  name={tenant.name}
                />
              )}
            </div>
          )}
          {showEmail && (
            <div
              className={styles.flexBox}
              style={{ backgroundColor: bgColorElement }}
            >
              <TenantEmail className={styles.email} email={tenant.email} />
            </div>
          )}
        </div>

        <div className={styles.footer}>
          <AppBlock
            hasApp={tenant?.alive}
            style={{ width: 40, backgroundColor: bgColorElement }}
          />
          {hasVisibleDocs && (
            <DocumentTenantBtn
              clientId={tenant.id}
              style={{ backgroundColor: bgColorElement }}
            />
          )}
          <TransportTenantBtn
            style={{ backgroundColor: bgColorElement }}
            tenant={tenant}
            addressId={addressId}
          />
        </div>
      </div>
    </div>
  );
};

export default TenantCardGeneral;
